/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[keep-placeholder]',
  standalone: false,
})
export class KeepPlaceholderDirective {
  constructor(private elementRef: ElementRef) {}

  @HostListener('focus') handleFocus() {
    this.elementRef.nativeElement.classList.add('keepPlaceHolder');
  }

  @HostListener('blur') handleBlur() {
    this.elementRef.nativeElement.classList.remove('keepPlaceHolder');
    this.elementRef.nativeElement.classList.remove('removePlaceholder');
  }

  @HostListener('window:keydown') handleKeyPress() {
    this.elementRef.nativeElement.classList.add('removePlaceholder');
    this.elementRef.nativeElement.classList.remove('keepPlaceHolder');
  }
}
